import React, { useEffect, useState } from 'react'
import { apiUrls } from 'constants/apiUrls';
import { Alert, Badge, Button, Col, Form, Row } from 'react-bootstrap'
import { BiPlus } from 'react-icons/bi';
import { BsX } from 'react-icons/bs';
import { toast } from 'react-toastify';
import { invoiceService } from 'services/invoiceService';
import DatePicker from 'react-datepicker';
import ProgressLoader from 'components/Loader/ProgressLoader';
import { allowNumberDecimal } from 'utils/inputValidator';
import { ddMMyyyy } from 'utils/dateFormatter';
import { bgPaymentStatus } from 'utils/bgColor';
import { roundTo } from 'utils/numberFormatter';

const InvoicePaymentForm = ({
    customerId,
    invoiceId,
    invoiceNo,
    invoiceAmount,
    paidAmount,
    paymentStatus,
    invoiceNotes,
    onSave,
    onCancel
}) => {
    const [isLoader, setIsLoader] = useState(false);
    const [message, setMessage] = useState();
    const [invoicePayment, setInvoicePayment] = useState({
        customerId: customerId,
        invoiceId: invoiceId,
        invoiceNo: invoiceNo,
        invoiceAmount: invoiceAmount,
        paymentStatus: paymentStatus,
        paidAmount: paidAmount,
        balanceAmount: (paymentStatus != 'Unpaid' ? roundTo(invoiceAmount - paidAmount) : ''),
        paidDate: new Date(),
        invoiceNotes: invoiceNotes
    });

    useEffect(() => { }, []);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (name === "paidAmount") {
            if (!allowNumberDecimal(e.target.value))
                return;
            else if (e.target.value > invoicePayment.invoiceAmount) {
                toast.warn("Paid cann't be greater than Invoice");
                return;
            }
        }

        setInvoicePayment((preValue) => ({
            ...preValue, [name]: (type === 'checkbox' ? checked : value)
        }));

        if (name === 'paidAmount') {
            invoicePayment.balanceAmount = 0;
            const invoiceAmount = invoicePayment.invoiceAmount;
            const paidAmount = value;

            if (invoiceAmount > 0 && paidAmount > 0) {
                invoicePayment.balanceAmount = (invoiceAmount - paidAmount);
            }

            setInvoicePayment((preValue) => ({
                ...preValue, "balanceAmount": invoicePayment.balanceAmount, "paymentStatus": invoicePayment.paymentStatus
            }));
        }
    }

    const setPaidDate = (value) => {
        setInvoicePayment((preValue) => ({
            ...preValue, "paidDate": value
        }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            setIsLoader(true);
            invoiceService.paymentInvoice(apiUrls.paymentInvoice(invoiceId), invoicePayment).then((res) => {
                setIsLoader(false);
                if (res === true) {
                    toast.success("Invoice payment successfully!");
                    onSave();
                }
            }).catch((err) => setIsLoader(false));
        }
    }

    const validateForm = () => {
        setMessage();
        if (!invoicePayment.customerId
            || !invoicePayment.invoiceId
            || !invoicePayment.paidAmount
            || !invoicePayment.paidDate
            || !invoicePayment.invoiceNotes) {
            setMessage("All star marked field required!");
            return false;
        }
        return true;
    }

    return (
        <>
            <Row className="justify-content-center">
                <Col md={12}>
                    {isLoader && <ProgressLoader />}
                    {message && (
                        <Alert variant='danger'>
                            {message}
                        </Alert>
                    )}
                    <Form onSubmit={handleSubmit} noValidate>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">InvoiceAmount</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='invoiceAmount'
                                    value={invoicePayment.invoiceAmount}
                                    disabled={true} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Paid Amount:*</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='paidAmount'
                                    value={invoicePayment.paidAmount}
                                    onChange={handleChange} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Balance</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    maxLength={10}
                                    name='balanceAmount'
                                    value={invoicePayment.balanceAmount}
                                    onChange={handleChange}
                                    disabled={true} />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Paid Date:*</Form.Label>
                            <Col sm="9">
                                <DatePicker
                                    selected={invoicePayment.paidDate}
                                    onSelect={setPaidDate}
                                    dateFormat={ddMMyyyy}
                                    className="form-control" />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Paid Notes:*</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    maxLength={100}
                                    name='invoiceNotes'
                                    value={invoicePayment.invoiceNotes}
                                    onChange={handleChange}
                                    placeholder="Paid By Description..." />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm="3">Paid Status:</Form.Label>
                            <Col sm="9">
                                <h4>
                                    <Badge bg={bgPaymentStatus(invoicePayment?.paymentStatus)}>
                                        {invoicePayment?.paymentStatus}
                                    </Badge>
                                </h4>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                            <Col sm={{ span: 9, offset: 3 }}>
                                <Button
                                    type="submit"
                                    variant='primary'
                                    className='mw-100'>
                                    <BiPlus size={20} /> Paid
                                </Button>
                                <Button
                                    type="button"
                                    variant='secondary'
                                    className='ms-3 mw-100'
                                    onClick={onCancel}>
                                    <BsX size={20} /> Cancel
                                </Button>
                            </Col>
                        </Form.Group>
                    </Form>
                </Col>
            </Row>
        </>
    )
}

export default InvoicePaymentForm;